// frontend/src/ChangePasswordPage.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from './api';
import HamburgerMenu from './HamburgerMenu';
import { useAuth } from './useAuth';
import { defaultHomePath } from './accessPolicy';

const getStyles = (theme) => {
    const isDark = theme === 'dark';
    const colors = {
        background: isDark ? '#1e1e1e' : '#fff',
        text: isDark ? '#e0e0e0' : '#212529',
        border: isDark ? '#444' : '#ccc',
        link: isDark ? '#6cb2f7' : '#007bff',
        buttonBg: isDark ? '#6cb2f7' : '#007bff',
        buttonText: isDark ? '#121212' : '#fff',
        menuItemColor: isDark ? '#e0e0e0' : '#333',
        success: isDark ? '#4caf50' : '#28a745',
        error: isDark ? '#f44336' : '#dc3545',
    };

    return {
        container: { width: '500px', margin: '40px auto', fontFamily: 'sans-serif', border: `1px solid ${colors.border}`, padding: '20px 40px', borderRadius: '8px', backgroundColor: colors.background, color: colors.text },
        formGroup: { marginBottom: '15px' },
        label: { display: 'block', marginBottom: '5px', fontWeight: 'bold' },
        input: { width: '100%', padding: '10px', boxSizing: 'border-box', backgroundColor: colors.background, color: colors.text, border: `1px solid ${colors.border}`, borderRadius: '4px' },
        button: { width: '100%', padding: '10px 15px', backgroundColor: colors.buttonBg, color: colors.buttonText, border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '16px' },
        pageHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
        header: { fontSize: '24px', margin: 0 },
        menuItem: {
            padding: '10px 15px',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            display: 'block',
            textDecoration: 'none',
            color: colors.menuItemColor,
        },
        menuItemButton: {
            background: 'none',
            border: 'none',
            padding: '10px 15px',
            width: '100%',
            textAlign: 'left',
            cursor: 'pointer',
            fontSize: '16px',
            fontFamily: 'sans-serif',
            color: colors.menuItemColor,
        },
        message: { marginTop: '20px', padding: '10px', borderRadius: '4px', textAlign: 'center' },
        success: { backgroundColor: colors.success, color: colors.buttonText },
        error: { backgroundColor: colors.error, color: colors.buttonText },
    };
};

function ChangePasswordPage({ theme }) {
    const styles = getStyles(theme);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const navigate = useNavigate();
    const { isStaff, groups } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setIsError(false);

        if (newPassword !== confirmPassword) {
            setMessage('New passwords do not match.');
            setIsError(true);
            return;
        }

        try {
            await api.put('/change-password/', {
                old_password: oldPassword,
                new_password: newPassword,
            });
            setMessage('Password changed successfully!');
            setIsError(false);
            setTimeout(() => navigate(defaultHomePath({ isStaff, groups })), 2000);
        } catch (err) {
            setMessage(err.response?.data?.old_password?.[0] || 'An error occurred.');
            setIsError(true);
        }
    };


    return (
        <div style={styles.container}>
            <div style={styles.pageHeader}>
                <HamburgerMenu theme={theme}/>
                <h2 style={styles.header}>Change Password</h2>
                <div style={{ width: '45px' }}></div>
            </div>
            <form onSubmit={handleSubmit}>
                <div style={styles.formGroup}>
                    <label style={styles.label}>Current Password</label>
                    <input type="password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} style={styles.input} required />
                </div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>New Password</label>
                    <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} style={styles.input} required />
                </div>
                <div style={styles.formGroup}>
                    <label style={styles.label}>Confirm New Password</label>
                    <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} style={styles.input} required />
                </div>
                <button type="submit" style={styles.button}>Update Password</button>
            </form>
            {message && (
                <div style={{...styles.message, ...(isError ? styles.error : styles.success)}}>
                    {message}
                </div>
            )}
        </div>
    );
}

export default ChangePasswordPage;